'use client';

import AppLayout from '../../layouts/AppLayout/AppLayout';
import { LOADING_MESSAGES } from '../../utils/loadingMessages';
import { AstronautArtwork } from '../common/AstronautArtwork';
import styles from '../common/AstronautArtwork.module.scss';
import Button from '../common/Button';

interface NotFoundViewProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onAction?: () => void;
}

export const NotFoundView = ({
  title = 'Page Not Found.',
  subtitle = "This page doesn't exist or has been removed.",
  buttonText = 'Go Home',
  onAction = () => (window.location.href = '/')
}: NotFoundViewProps) => (
  <AppLayout>
    <div className="anim-enter flex h-full w-full flex-col items-center justify-center py-12 [--enter-duration:500ms]">
      <AstronautArtwork
        size={1.4}
        messages={LOADING_MESSAGES}
        leftDigit="4"
        rightDigit="4"
      >
        <div className={styles.center} style={{ pointerEvents: 'auto' }}>
          <div className={`${styles.sorry} text-textPrimary`}>
            <div>
              {title}
              <br />
              <span className="text-base text-textSecondary">{subtitle}</span>
            </div>
            <Button
              variant="TRANSPARENT"
              borderTransparent={false}
              onClick={onAction}
              text={buttonText}
            />
          </div>
        </div>
      </AstronautArtwork>
    </div>
  </AppLayout>
);
